module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetLow.47220f1.jpg";